export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const FETCH_TASK = 'FETCH_TASK'
export const LOGIN = 'LOGIN'
export const ERROR = 'ERROR'
export const LOGOUT = 'LOGOUT'
export const RESET_PASS = 'RESET_PASS'
export const CHANGE_PASS = 'CHANGE_PASS'
export const LOGIN_STATUS = 'LOGIN_STATUS'
export const GET_LAN = 'GET_LAN'
export const SET_LAN = 'SET_LAN'


// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js